var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLoaderi = function SvgLoaderi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: props.color || 'currentColor'
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.226 7.417-1.24.11a.75.75 0 1 1-.133-1.494l3.182-.284a.75.75 0 0 1 .817.729l.08 3.3a.75.75 0 0 1-1.498.038l-.035-1.45a5.91 5.91 0 0 0 .436 7.864 5.87 5.87 0 0 0 3.513 1.69.75.75 0 0 1-.168 1.492 7.38 7.38 0 0 1-4.407-2.12 7.41 7.41 0 0 1-.545-9.864zm10.36 8.25a5.907 5.907 0 0 0-3.856-9.571.75.75 0 0 1 .185-1.488c1.58.196 3.106.9 4.317 2.1a7.41 7.41 0 0 1 .567 9.836l1.215-.136a.75.75 0 1 1 .168 1.492l-3.175.355a.747.747 0 0 1-.832-.711l-.153-3.288a.75.75 0 1 1 1.498-.069l.07 1.47z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLoaderi);
export default ForwardRef;